"use client";

import React, { useState, useEffect } from "react";
import { usePathname } from "next/navigation";
import LiveChat from "./LiveChat";
import ChatTrigger from "./ChatTrigger";
import { trackChatOpen } from "@/lib/analytics";

const ChatWidget = () => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth >= 1024); // lg breakpoint
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // Don't show chat widget on the chat page itself
  if (pathname === "/chat") {
    return null;
  }

  if (typeof pathname === "string" && pathname.startsWith("/studio")) {
    return null;
  }

  const handleToggleChat = () => {
    // Opening is the intent signal; closing is not worth an event.
    if (!isChatOpen) trackChatOpen();
    setIsChatOpen(!isChatOpen);
  };

  const handleCloseChat = () => {
    setIsChatOpen(false);
  };

  return (
    <>
      <ChatTrigger
        onClick={handleToggleChat}
        isActive={isChatOpen}
        useDesktop={isDesktop}
      />
      <LiveChat isOpen={isChatOpen} onClose={handleCloseChat} />
    </>
  );
};

export default ChatWidget;
